<template>
  <div>
    <v-progress-linear v-if="cargando" indeterminate color="purple" class="mb-2" />

    <ag-grid-vue
      :gridOptions="gridOptions"
      class="ag-theme-balham ag-grid-listado-conceptos"
      :columnDefs="columnDefs"
      :defaultColDef="defaultColDef"
      @grid-ready="onGridReady"
      :rowData="items"
      rowSelection="single"
      colResizeDefault="shift"
      :animateRows="false"
      :floatingFilter="true"
      :pagination="false"
      :rowClassRules="rowClassRules"
      @selection-changed="onSelectionChanged"
      @first-data-rendered="onFirstDataRendered"
      :alwaysShowVerticalScroll="true"
      :suppressPaginationPanel="true">
    </ag-grid-vue>
  </div>
</template>
  
<script>
import listadoAgGridMixin from '../mixins/listado-ag-grid.mixin';
import { cellRendererNumeroRegistro } from '../utils/funciones';

export default {
  name: 'ListadoConceptos',
  mixins: [listadoAgGridMixin],
  data() {
    return {
      columnDefs: [
        {
          headerName: 'N° REGISTRO',
          cellRenderer: cellRendererNumeroRegistro,
          filter: false,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: false,
          minWidth: 100,
          maxWidth: 100,
        },
        {
          headerName: 'NOMBRE',
          field: 'nombre',
          minWidth: 300,
        },
        {
          headerName: 'DESCRIPCIÓN',
          field: 'descripcion',
          minWidth: 300,
          maxWidth: 300,
        },
        {
          headerName: 'CREADO EN',
          field: 'creadoEn',
          filter: false,
          minWidth: 200,
          maxWidth: 200,
        },
        {
          headerName: 'ACTUALIZADO EN',
          field: 'actualizadoEn',
          filter: false,
          minWidth: 200,
          maxWidth: 200,
        },
        {
          headerName: 'ELIMINADO EN',
          field: 'eliminadoEn',
          filter: false,
          minWidth: 200,
          maxWidth: 200,
        },
      ],
    };
  },
};
</script>
  
<style>
@import '~ag-grid-community/dist/styles/ag-grid.css';
@import '~ag-grid-community/dist/styles/ag-theme-balham.css';

.ag-grid-listado-conceptos {
  height: calc(var(--vh, 1vh) * 100 - 14rem);
}
</style>
  